import { createContext } from 'react';

export const IdleTimeContext = createContext();
